import { render, staticRenderFns } from "./DisbursementDetail.vue?vue&type=template&id=3830a28e&scoped=true&"
import script from "./DisbursementDetail.vue?vue&type=script&lang=js&"
export * from "./DisbursementDetail.vue?vue&type=script&lang=js&"
import style0 from "./DisbursementDetail.vue?vue&type=style&index=0&id=3830a28e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3830a28e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VCol,VContainer,VDataTable,VIcon})
